export var AppetiteStatus;
(function (AppetiteStatus) {
    AppetiteStatus["Active"] = "active";
    AppetiteStatus["Archived"] = "archived";
})(AppetiteStatus || (AppetiteStatus = {}));
//# sourceMappingURL=appetite-status.js.map